import { render, staticRenderFns } from "./ImportManagersModal.vue?vue&type=template&id=5ced61dd"
import script from "./ImportManagersModal.vue?vue&type=script&lang=js"
export * from "./ImportManagersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports